// import { CompartmentList } from "../genetic_optimize/CompartmentList";
export enum Covers {
  COVER = "Deckel",
  BASE = "Boden",
  FRONT_COVER = "Deckel Vorne",
  BACK_COVER = "Deckel Hinten",
  TOP_COVER = "Deckel Oben",
}
